import React, { useEffect, useState } from 'react';
import './ParachuteAnimation.css';

// Parachute component with job title
const Parachute = ({ title, delay, duration, left, size }) => {
  return (
    <div 
      className="parachute-container" 
      style={{ 
        animationDelay: `${delay}s`, 
        animationDuration: `${duration}s`,
        left: `${left}%`,
        transform: `scale(${size})`
      }}
    >
      <div className="parachute">
        <svg width="50" height="60" viewBox="0 0 50 60" xmlns="http://www.w3.org/2000/svg">
          {/* Parachute Canopy */}
          <path 
            d="M5 20 C5 10, 45 10, 45 20 L35 30 C35 30, 25 25, 15 30 L5 20 Z" 
            fill={`hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`}
          />
          
          {/* Parachute Lines */}
          <path d="M15 30 L20 50" stroke="#fff" strokeWidth="1.5" fill="none" />
          <path d="M25 28 L25 50" stroke="#fff" strokeWidth="1.5" fill="none" />
          <path d="M35 30 L30 50" stroke="#fff" strokeWidth="1.5" fill="none" />
          
          {/* Person/Figure */}
          <circle cx="25" cy="52" r="2" fill="#fff" />
        </svg>
      </div>
      <div className="job-title">{title}</div>
    </div>
  );
};

const ParachuteAnimation = () => {
  const jobTitles = [
    "Software Engineer", 
    "Product Manager", 
    "UX Designer", 
    "Data Scientist", 
    "Marketing Manager",
    "DevOps Engineer",
    "Full Stack Developer",
    "Project Manager",
    "UI Designer",
    "Content Writer",
    "Sales Executive"
  ];
  
  const [parachutes, setParachutes] = useState([]);
  
  useEffect(() => {
    // Create an array of parachute objects with random properties
    const newParachutes = [];
    for (let i = 0; i < 8; i++) {
      newParachutes.push({
        id: i,
        title: jobTitles[Math.floor(Math.random() * jobTitles.length)],
        delay: Math.random() * 5,
        duration: 15 + Math.random() * 10,
        left: 10 + Math.random() * 80,
        size: 0.5 + Math.random() * 0.5
      });
    }
    setParachutes(newParachutes);
    
    // Periodically replace parachutes to keep animation fresh
    const interval = setInterval(() => {
      setParachutes(prev => {
        const updated = [...prev];
        const replaceIndex = Math.floor(Math.random() * updated.length);
        updated[replaceIndex] = {
          id: Date.now(),
          title: jobTitles[Math.floor(Math.random() * jobTitles.length)],
          delay: 0,
          duration: 15 + Math.random() * 10,
          left: 10 + Math.random() * 80,
          size: 0.5 + Math.random() * 0.5
        };
        return updated;
      });
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="parachute-animation">
      {parachutes.map(p => (
        <Parachute 
          key={p.id}
          title={p.title}
          delay={p.delay}
          duration={p.duration}
          left={p.left}
          size={p.size}
        />
      ))}
    </div>
  );
};

export default ParachuteAnimation;